import en from "./en";

export default {
    ...en,
    metaTitleBrand: "LOYA SPORT",
    metaTitleHome: "首页",
    metaTitleProducts: "产品中心",
    metaTitleProductDetail: "产品详情",
    metaTitleCustomService: "定制服务",
    metaTitleSolutions: "解决方案",
    metaTitleAbout: "关于我们",
    metaTitleContact: "联系我们",
    metaTitleBlog: "博客",
    metaTitleLogin: "登录",
    metaTitleAdmin: "管理后台",
    metaTitleSystemSetup: "系统设置",
    contactDocsTitle: "可提供单证",
    contactDocsDesc: "商业发票、装箱单、物流协调全流程支持。",
    contactSampleTitle: "样品服务",
    contactSampleDesc: "OEM及贴牌项目可快速安排样品。",
    searchOverlayPlaceholder: "按名称搜索产品...",
    searchOverlaySubmitAria: "提交搜索",
    searchOverlaySubmitTitle: "搜索",
    searchOverlayHintPrefix: "按",
    searchOverlayHintSuffix: "可查看所有匹配产品，或直接选择下方快捷结果。",
    searchOverlayCloseAria: "关闭搜索",
    searchOverlayQuickResults: "快速结果",
    searchOverlayQuickResultsAria: "快速搜索结果",
    searchOverlayFallbackCategory: "瑜伽配件",
    searchOverlayHistory: "搜索历史",
    searchOverlayClear: "清空",
    searchOverlayNoHistory: "暂无搜索记录",
    searchOverlayRecommended: "推荐关键词",
    searchOverlayFallbackKeyword: "瑜伽垫",
    blogHeroKicker: "内容中心",
    blogHeroTitle: "采购洞察与选品指南",
    blogSearchAria: "搜索文章",
    blogCategoryAria: "文章分类",
    blogReadingTimeMin: "分钟阅读",
    blogShowLess: "收起内容",
    blogFeaturedPlaceholder: "精选洞察",
    blogPaginationAria: "博客分页",
    blogCtaAria: "博客行动入口",
    requestFreeSample: "申请免费样品",
    factoryStatsSince: "始于2008年出口",
    factoryStatsCapacity: "月产能10,000+件",
    factoryStatsExport: "服务50+个国家",
    factoryStatsCert: "ISO 9001 & BSCI认证",
    aboutHeroTitle: "年轻、专业、专注——我们是您的瑜伽供应链整合专家",
    aboutHeroBody: "楼亚科技（LOYA SPORT）位于中国湖南长沙。我们拥有一支充满活力的专业团队，致力于为海外买家提供精挑细选的瑜伽产品供应链整合服务，涵盖从源头工厂筛选到深度定制开发的全流程。",
    aboutAddress: "公司地址：中国湖南省长沙市岳麓区旺龙路瑞合科创大厦",
    aboutTeamTitle: "充满活力的专业团队",
    aboutTeamBody: "我们年轻但经验丰富，深谙瑜伽行业的市场需求与技术细节。通过严谨的选品逻辑和高效的响应速度，确保每一件交付的产品都符合高标准的商业预期。",
    aboutCustomizationTitle: "全方位定制化服务",
    aboutCustomizationBody: "从LOGO丝印、包装设计到产品功能模具开发，我们为客户提供灵活且深入的定制方案，助力您的品牌在市场中脱颖而出。",
    aboutFactoryPartnerTitle: "优质工厂合作伙伴",
    aboutFactoryPartnerBody: "我们深入工厂一线，与具备ISO/BSCI认证的优质制造基地紧密合作，从源头管控品质，确保量产的稳定性和交付的准时性。",
    aboutHeroKicker: "供应链整合服务",
    aboutMetric1: "围绕产品、包装与交付沟通的单一项目窗口",
    aboutMetric2: "多工厂资源在统一采购与跟进结构下协同",
    aboutMetric3: "面向进口商、零售商、分销商与贴牌买家的B2B流程",
    aboutPlaceholderNote: "我们的角色是减少买家、供应商与工厂执行团队之间的碎片化沟通，让项目推进更清晰、盲区更少。",
    aboutHeroImageAlt: "面向出口买家的供应链协同会议",
    aboutHeroCaption: "从询盘到出货，我们负责通常会分散在采购代理、工厂与物流联系人之间的关键细节协同。",
    aboutOfficeImageAlt: "长沙楼亚科技办公大楼",
    aboutOfficeCaption: "长沙楼亚科技办公室",
    aboutTeamImageAlt: "长沙办公室专业团队",
    aboutFactoryImageAlt: "瑜伽垫生产线与质量流程",
    aboutFactoryCollageAlt: "工厂仓储与生产细节",
    aboutWhatWeDoTitle: "我们具体在做什么",
    aboutWhatWeDoBody1: "很多买家需要的不只是目录，而是能把商业需求和工厂执行真正连接起来的合作方。我们会协同供应商筛选、价格沟通、产品打样、包装落地、生产跟进、质检对齐与出口准备。",
    aboutWhatWeDoBody2: "我们不会把产品细节、包装文件、交付节奏和订单变更分散给多个联系人，而是将流程集中到一个可追责的沟通链路中持续推进。",
    aboutBadge1: "供应商匹配",
    aboutBadge2: "样品跟进",
    aboutBadge3: "包装执行",
    aboutBadge4: "出货准备",
    aboutSideImageAlt: "买家沟通与项目评审",
    aboutIntegratedCapabilitiesTitle: "一体化供应能力",
    aboutSideCaption: "我们聚焦于让海外买家的采购链条更易管理，强调稳定协同而非孤立式交易。",
    aboutCapabilityCard1Title: "供应网络整合",
    aboutCapabilityCard1Body: "我们把工厂资源、品类理解和采购控制整合到面向买家的统一工作流中，让您无需自行协调多方。",
    aboutCapabilityCard2Title: "商务与技术协同",
    aboutCapabilityCard2Body: "从报价、打样、包装细节到规格确认与生产节点，我们确保商务侧与工厂侧信息保持一致。",
    aboutCapabilityCard3Title: "出口订单执行",
    aboutCapabilityCard3Body: "我们围绕验货、单证、订舱和出货准备全程跟进，降低沟通断层与交付风险。",
    aboutOperatingModel1: "基于目标市场与价格带进行品类采购与工厂匹配。",
    aboutOperatingModel2: "在锁定量产前完成打样、规格评审与包装协同。",
    aboutOperatingModel3: "在统一项目流下进行生产跟进、质量节点管理与发运准备。",
    aboutOperatingModel4: "产品、包装、单证与交付进度统一在单一沟通窗口推进。",
    aboutWhoWeServeTitle: "我们服务谁",
    aboutBuyerScenario1Title: "面向进口商与分销商",
    aboutBuyerScenario1Body: "我们帮助整合产品线、比较供应方案，并构建更稳定的跨品类补货计划。",
    aboutBuyerScenario2Title: "面向连锁零售与电商卖家",
    aboutBuyerScenario2Body: "我们支持可直接上架的组合、贴牌包装和可复用的订单沟通流程。",
    aboutBuyerScenario3Title: "面向产品线扩展中的品牌方",
    aboutBuyerScenario3Body: "我们作为概念、生产与出口执行之间的协同层，帮助内部团队更快推进项目。",
    aboutWorkflowTitle: "我们的流程如何组织",
    aboutWorkflowStep1: "需求接收与目标产品澄清",
    aboutWorkflowStep2: "供应商匹配、报价与打样计划",
    aboutWorkflowStep3: "规格、包装与合规评审",
    aboutWorkflowStep4: "生产跟进、检验与出货准备",
    aboutWhyIntegratorTitle: "为什么买家会选择供应链整合方",
    aboutWhyIntegratorBody1: "当采购跨越多个供应商、包装协作方与发运节奏时，最大的风险往往不是首次报价，而是订单推进后的对齐失效。",
    aboutWhyIntegratorList1: "规格信息可能在报价到量产之间发生偏移。",
    aboutWhyIntegratorList2: "包装与品牌细节可能因沟通碎片化而延误。",
    aboutWhyIntegratorList3: "验货、单证与出运准备可能与原始商务承诺脱节。",
    aboutWhyIntegratorBody2: "我们的价值在于把这些环节持续连接。我们作为买家预期与供应执行之间的协同层，确保决策可追踪、时间可跟进、交接风险可降低。",
    aboutTalkToTeam: "联系团队",
    aboutPositioningTitle: "我们的定位",
    aboutPositioningBody: "LOYA SPORT 定位为面向出口健身产品的供应链整合方。我们帮助客户以更清晰的协同、更稳健的供应组织和更可控的路径完成从采购到出货。",
    aboutMetric1Label: "单一项目窗口",
    aboutMetric2Label: "多工厂协同",
    aboutMetric3Label: "B2B工作流",
    aboutWhatWeDoBody2Extended: "我们作为您的执行扩展，处理那些通常会让内部采购团队精疲力竭的碎片化细节。",
    aboutWhyIntegratorBody2Extended: "与其在数十个联系人之间追逐进度，不如通过单一的协同层让交付确定性更高。",
    aboutHeroCaptionExtended: "我们不仅跟进“何时发货”，更确保“发什么货”以及“如何发货”完全符合您的商业预期。",
    aboutCapabilityCard1BodyExtended: "通过整合的分散供应模式，您既能获得专业工厂的产能，又能享受集中化管理的效率。",
    aboutCapabilityCard2BodyExtended: "我们参与包装刀模、品牌色彩对齐和说明书合规评审，确保大货与样品一致。",
    aboutCapabilityCard3BodyExtended: "我们的单证团队处理商业发票、装箱单与产地证，并协助协调多品类拼箱。",
    aboutIntegratedCapabilitiesTitleExtended: "端到端协同能力",
    aboutSideCaptionExtended: "LOYA SPORT 旨在消除跨境采购中的“最后一百米”执行盲点。",
    aboutWhatWeDoTitleExtended: "深度执行支持",
    aboutBadge1Extended: "品类专家匹配",
    aboutBadge2Extended: "质量节点控制",
    aboutBadge3Extended: "品牌合规评审",
    aboutBadge4Extended: "发运合并方案",
    aboutBuyerScenario1TitleExtended: "进口分销商方案",
    aboutBuyerScenario2TitleExtended: "零售与电商方案",
    aboutBuyerScenario3TitleExtended: "品牌商协作方案",
    aboutWorkflowTitleExtended: "标准作业程序 (SOP)",
    aboutWorkflowStep1Extended: "精准定义SKU规格与合规要求",
    aboutWorkflowStep2Extended: "筛选、初选与打样周期启动",
    aboutWorkflowStep3Extended: "品牌资料锁定与预产样 sign-off",
    aboutWorkflowStep4Extended: "量产、批次质检与合并出货",
    aboutMetric1Title: "1",
    aboutMetric2Title: "Multi",
    aboutMetric3Title: "B2B",
    solutionsHeroKicker: "解决方案",
    solutionsHeroTitle: "为不同买家类型选择合适的采购路径",
    solutionsHeroBody: "以可视化方式呈现渠道匹配、场景匹配与产品组合规划。",
    solutionsTalkToSales: "联系销售",
    solutionsBrowseProducts: "浏览产品",
    solutionsHeroImageAlt: "面向瑜伽与轻健身买家的B2B采购解决方案",
    solutionsHeroBadgeTitle: "方案匹配",
    solutionsHeroBadgeBody: "买家类型 + 使用场景 + 产品组合",
    solutionsBuyerTypeTitle: "买家类型方案",
    solutionsViewMatchingProducts: "查看匹配产品",
    solutionsScenarioPlansTitle: "场景方案",
    solutionsProgramMixesTitle: "推荐组合方案",
    solutionsNextStepKicker: "下一步",
    solutionsNextStepTitle: "需要针对您市场的定制组合吗？",
    solutionsNextStepBody: "告诉我们您的买家类型、目标产品和目的市场，我们将给出可执行的组合路径建议。",
    solutionsRequestPlan: "申请方案建议",
    solutionsExploreOem: "查看OEM支持",
    solutionsBuyerCard1Title: "批发商",
    solutionsBuyerCard1Subtitle: "面向大宗项目的快速组合搭建。",
    solutionsBuyerCard1Need1: "需要稳定的大货供应并降低缺货风险",
    solutionsBuyerCard1Need2: "需要可整箱销售的SKU组合以提升周转",
    solutionsBuyerCard1Need3: "需要可预测交期的重复补货节奏",
    solutionsBuyerCard1Tag1: "大货组合",
    solutionsBuyerCard1Tag2: "整箱即售",
    solutionsBuyerCard1Tag3: "循环补货",
    solutionsBuyerCard2Title: "零售商",
    solutionsBuyerCard2Subtitle: "上架友好包装与稳定补货节奏。",
    solutionsBuyerCard2Need1: "需要从入门到高端的清晰价格梯度",
    solutionsBuyerCard2Need2: "需要条码就绪包装以加快上架",
    solutionsBuyerCard2Need3: "需要畅销品的稳定补货保障",
    solutionsBuyerCard2Tag1: "零售包装",
    solutionsBuyerCard2Tag2: "条码支持",
    solutionsBuyerCard2Tag3: "陈列友好组合",
    solutionsBuyerCard3Title: "健身品牌",
    solutionsBuyerCard3Subtitle: "用于品牌扩展的贴牌项目方案。",
    solutionsBuyerCard3Need1: "需要在不重建完整供应链的前提下完成品牌定制",
    solutionsBuyerCard3Need2: "需要匹配品牌定位的包装风格",
    solutionsBuyerCard3Need3: "需要更快的打样到上市节奏",
    solutionsBuyerCard3Tag1: "Logo应用",
    solutionsBuyerCard3Tag2: "定制包装",
    solutionsBuyerCard3Tag3: "品牌线扩展",
    solutionsBuyerCard4Title: "瑜伽馆",
    solutionsBuyerCard4Subtitle: "课程套装、辅具与训练组合。",
    solutionsBuyerCard4Need1: "需要新会员与体验课的入门套装",
    solutionsBuyerCard4Need2: "需要适合高频课程的耐用辅具",
    solutionsBuyerCard4Need3: "需要可用于增购的实用组合定价",
    solutionsBuyerCard4Tag1: "入门套装",
    solutionsBuyerCard4Tag2: "课程辅具",
    solutionsBuyerCard4Tag3: "会员升级包",
    solutionsBuyerCard5Title: "Amazon卖家",
    solutionsBuyerCard5Subtitle: "平台友好的组合与包装方案。",
    solutionsBuyerCard5Need1: "需要紧凑组合结构以控制物流成本",
    solutionsBuyerCard5Need2: "需要有利于转化的产品组合",
    solutionsBuyerCard5Need3: "需要降低退货率的包装质量",
    solutionsBuyerCard5Tag1: "紧凑组合",
    solutionsBuyerCard5Tag2: "图文友好包装",
    solutionsBuyerCard5Tag3: "低摩擦上线",
    solutionsBuyerCard6Title: "电商企业",
    solutionsBuyerCard6Subtitle: "适合线上复购的视觉优先产品。",
    solutionsBuyerCard6Need1: "需要在广告与社媒表现稳定的核心SKU",
    solutionsBuyerCard6Need2: "需要灵活组合以提升客单价",
    solutionsBuyerCard6Need3: "需要季节活动的快速目录更新",
    solutionsBuyerCard6Tag1: "核心爆品",
    solutionsBuyerCard6Tag2: "组合策略",
    solutionsBuyerCard6Tag3: "快速上新",
    solutionsScenario1Title: "工作室入门套装",
    solutionsScenario1Body: "适用于课程、体验与会员包的上市就绪瑜伽组合。",
    solutionsScenario2Title: "恢复与按摩专区",
    solutionsScenario2Body: "适合健身房角落场景的按摩与恢复配件组合。",
    solutionsScenario3Title: "零售陈列方案",
    solutionsScenario3Body: "兼顾陈列效果与包装效率的均衡品类组合。",
    solutionsScenario4Title: "线上组合套餐",
    solutionsScenario4Body: "面向转化型商品页设计的紧凑型产品套装。",
    solutionsProgram1Title: "精品工作室启动包",
    solutionsProgram1Body: "面向中高端瑜伽馆会员体验而设计的核心辅具组合。",
    solutionsProgram1Item1: "专业级防滑TPE/橡胶垫",
    solutionsProgram1Item2: "高密度软木瑜伽砖 (一对)",
    solutionsProgram1Item3: "品牌刺绣拉伸带",
    solutionsProgram1SuitedFor: "瑜伽工作室、精品健身房、私教课包",
    solutionsProgram2Title: "零售渠道焕新组合",
    solutionsProgram2Body: "兼顾展示吸引力与补货周转速度的零售门店方案。",
    solutionsProgram2Item1: "带挂钩零售装瑜伽垫",
    solutionsProgram2Item2: "彩色阻力带展示装 (5磅-25磅)",
    solutionsProgram2Item3: "全彩印花运动巾",
    solutionsProgram2SuitedFor: "体育用品店、连锁商超、生活方式集合店",
    solutionsProgram3Title: "跨境电商转化包",
    solutionsProgram3Body: "优化包装体积以适配国际物流成本的高转化组合。",
    solutionsProgram3Item1: "紧凑型折叠瑜伽垫",
    solutionsProgram3Item2: "迷你泡沫轴与按摩球套装",
    solutionsProgram3Item3: "便携式收纳袋",
    solutionsProgram3SuitedFor: "Amazon卖家、独立站卖家、跨境分销",
    oemHeroKicker: "定制服务",
    oemHeroTitle: "贴牌项目与私有标签协同",
    oemHeroBody: "作为供应链整合方，我们负责将您的品牌视觉和规格要求落地为可交付的产品。从打样审核到包装合规，我们在工厂端为您把控每一个定制细节。",
    oemRequestQuote: "申请定制报价",
    oemHeroImageAlt: "瑜伽产品贴牌定制与品牌化过程",
    oemCapabilitiesTitle: "我们的定制支持范围",
    oemCapabilityCard1Title: "品牌视觉落地",
    oemCapabilityCard1Body: "支持丝印、压印、激光打标及织标定制。我们将根据材质为您选择最佳的 Logo 应用方式。",
    oemCapabilityCard2Title: "包装与合规评审",
    oemCapabilityCard2Body: "提供全彩包装、展示盒及彩插的设计评审，确保条码、合规标志及说明书在出货前符合目的市场要求。",
    oemCapabilityCard3Title: "多级样品评审",
    oemCapabilityCard3Body: "从数字模型到实物产前样，我们设置多个确认节点，确保大货生产前所有规格细节已 sign-off。",
    oemServiceHighlightsTitle: "定制服务亮点",
    oemServiceHighlight1Title: "起订量灵活配比",
    oemServiceHighlight1Body: "针对品牌初创阶段提供灵活的起订量支持。",
    oemServiceHighlight2Title: "品牌色彩对齐",
    oemServiceHighlight2Body: "提供专业的色卡对照，确保跨材质产品间的品牌色一致性。",
    oemServiceHighlight3Title: "文档管理支持",
    oemServiceHighlight3Body: "由单一窗口管理所有打样记录与包装文件版本。",
    oemServiceHighlight4Title: "多层质检管控",
    oemServiceHighlight4Body: "对定制部分的视觉一致性进行专项检验。",
    oemIntro: "我们不仅是供应商，更是您的品牌执行扩展团队。我们理解 B2B 定制中的复杂性，并将其简化为可预测的交付路径。",
    oemTitle: "贴牌项目与私有标签协同",
    oemStartProject: "启动定制项目",
    oemBrowseProducts: "浏览基础产品",
    oemVisualGuide: "定制可视化指南",
    oemVisualAlt: "OEM 定制选项与流程指南",
    oemVisualPlaceholder: "未找到定制示意图，请将图片添加到 frontend/public/assets/about/oem-customization-guide.jpg",
    oemServiceShowcaseAria: "OEM 与 ODM 定制服务",
    oemServiceShowcaseTitle: "OEM 与 ODM 定制服务",
    oemServiceShowcaseBody: "从需求确认到生产交付，提供灵活的一站式协同支持。",
    oemCapabilityKicker: "可定制范围",
    oemCapabilityTitle: "从 Logo 应用到包装落地",
    oemCompareHeadBody: "四种常见路径，直观展示基础款与定制款差异。",
    oemCompareBaseSuffix: "基础版本",
    oemCompareOptionsSuffix: "定制选项",
    oemCompareCustomizedSuffix: "定制版本",
    oemCompare1Body: "从素款产品到品牌化呈现。",
    oemCompare1BeforeLabel: "基础款",
    oemCompare1AfterLabel: "加 Logo 后",
    oemCompare1CustomizationLabel: "Logo 定制",
    oemCompare2Body: "从标准规格到市场匹配配色。",
    oemCompare2BeforeLabel: "标准款",
    oemCompare2AfterLabel: "定制配色",
    oemCompare3Body: "从基础包装到零售就绪展示。",
    oemCompare3BeforeLabel: "基础包装",
    oemCompare3AfterLabel: "零售就绪",
    oemCompare4Title: "组合开发",
    oemCompare4Body: "从单品供货到渠道化套装方案。",
    oemCompare4BeforeLabel: "单品",
    oemCompare4AfterLabel: "组合套装",
    oemCompare4CustomizationLabel: "组合逻辑",
    oemCompare4Item1: "工作室套装",
    oemCompare4Item2: "Amazon 套包",
    oemCompare4Item3: "促销组合",
    oemCasesTitle: "定制案例",
    oemCase1Title: "精品工作室入门线",
    oemCase1Summary: "面向精品工作室开业的入门套装方案。",
    oemCase1Details: "12 天内完成 Logo 方案确认并通过样品审核。",
    oemCase2Title: "零售贴牌焕新项目",
    oemCase2Summary: "通过包装升级提升门店陈列一致性。",
    oemCase2Details: "显著缩短客户确认周期，提升零售展示统一度。",
    oemCase3Title: "平台化健身组合包",
    oemCase3Summary: "面向电商平台的组合与包装协同方案。",
    oemCase3Details: "彩卡、条码与量产评审流程一次打通。",
    oemProcess1Title: "提交项目需求",
    oemProcess1Body: "提供目标产品、Logo 文件、参考图、包装预期与预计采购量。",
    oemProcess2Title: "确认规格与起订量",
    oemProcess2Body: "同步材质方案、品牌工艺、合规要点、交期与可执行起订量。",
    oemProcess3Title: "样品打样与修订",
    oemProcess3Body: "安排样品或视觉稿确认，根据反馈迭代并锁定量产标准。",
    oemProcess4Title: "量产与质检",
    oemProcess4Body: "按确认样执行生产，进行包装检查与出货前质量复核。",
    oemOrderingFlowKicker: "下单流程",
    oemOrderingFlowTitle: "五步完成沟通与下单",
    oemContactFlow1: "初步询盘：提交目标产品、市场与品牌需求。",
    oemContactFlow2: "方案报价：确认样品计划、交期与包装选项。",
    oemContactFlow3: "样品确认：锁定规格细节与订单参数。",
    oemContactFlow4: "执行生产：支付定金后安排生产、检验与订舱。",
    oemContactFlow5: "交付收尾：尾款、单证与售后跟进同步完成。",
    oemContactSideTitle: "准备讨论您的 OEM 需求？",
    oemContactSideBody: "提交 Logo、目标数量和包装想法，我们会给出可执行的报价路径与样品建议。",
    oemContactSideNote: "建议首轮通过邮件或询盘表单提交设计稿与目标出货窗口。",
    oemContactSideCta: "联系销售团队",
    oemIntroButton: "联系团队进行定制咨询",
    oemStepsTitle: "典型的 OEM/ODM 合作路径",
    oemStepsBody: "标准化的项目管理，确保从概念到入库的每一步都可追踪。",
    oemStepsLead: "项目进度对齐",
    oemStep1Title: "规格定义与初步报价",
    oemStep1Body: "明确材质、尺寸、颜色和预计采购量，建立基准报价。",
    oemStep2Title: "打样周期与视觉评审",
    oemStep2Body: "制作首轮实物样，对 Logo 效果和包装设计进行实物审核。",
    oemStep3Title: "产前样 sign-off",
    oemStep3Body: "在批量生产前锁定所有细节，作为最终验收标准。",
    oemStep4Title: "批量生产与质量监控",
    oemStep4Body: "按照约定的质量标准和交付节奏进行生产跟进。",
    oemCaseStudiesTitle: "定制案例参考",
    oemCaseCard1Title: "北美连锁工作室：课程专属套装",
    oemCaseCard1Body: "通过单一窗口完成了全系列垫、砖、带的品牌色对齐与一体化发运。",
    oemCaseCard2Title: "海外运动品牌：环保产品线扩展",
    oemCaseCard2Body: "协助客户完成了从软木、再生橡胶材质的筛选到无塑包装的合规评审。",
    oemCaseCard3Title: "全球电商卖家：高转化组合规划",
    oemCaseCard3Body: "通过优化包装结构和组合逻辑，帮助客户在提升客单价的同时显著降低了单位运费。",
    oemNextStepTitle: "准备好启动您的定制项目了吗？",
    oemNextStepBody: "立即联系我们，获取针对您品牌需求的初步方案与报价建议。",
    oemStartConversation: "开始对话",
    oemCompareTitle: "定制服务标准对照",
    oemCompareSubtitle: "从基础贴牌到深度定制的灵活支持。",
    oemCompareCategory1: "标准定制 (Standard)",
    oemCompareCategory2: "深度定制 (Custom)",
    oemCompare1Title: "快速 Logo 贴牌",
    oemCompare1Desc: "基于现有热门型号，快速应用您的品牌 Logo。",
    oemCompare1Label: "品牌 Logo 应用",
    oemCompare1Item1: "单色丝印/压印",
    oemCompare1Item2: "标准说明书插卡",
    oemCompare1Item3: "常规包装方式",
    oemCompare2Title: "规格与色彩调整",
    oemCompare2Desc: "针对特定市场定位进行色彩、纹理或厚度的参数微调。",
    oemCompare2Label: "参数化定制",
    oemCompare2CustomizationLabel: "颜色与纹理微调",
    oemCompare2Item1: "指定潘通色定制",
    oemCompare2Item2: "特定纹理/模具选择",
    oemCompare2Item3: "多语言全彩外盒",
    oemCompare3Title: "一体化组合方案",
    oemCompare3Desc: "围绕特定的使用场景，整合跨品类产品与差异化包装。",
    oemCompare3Label: "方案整合定制",
    oemCompare3CustomizationLabel: "跨品类整合",
    oemCompare3Item1: "品牌专署产品组合",
    oemCompare3Item2: "全链路包装设计评审",
    oemCompare3Item3: "拼箱与发运计划管理",
    contactTitle: "联系我们",
    contactHeroKicker: "商务咨询",
    contactHeroTitle: "开始我们的协同之旅",
    contactHeroBody: "无论是产品询价、定制咨询还是供应链合作，我们的团队都随时准备为您提供支持。",
    contactIntro: "我们提倡通过一个商业团队管理多工厂协同，减少您的沟通成本。如果您有明确的采购计划，请填写下方表单，我们将为您匹配合适的资源。",
    contactSendInquiry: "提交询盘",
    contactHeroImageAlt: "专业的B2B客户服务团队",
    contactInfoTitle: "联系信息",
    contactInfoEmail: "邮箱",
    contactInfoPhone: "电话",
    contactInfoHours: "工作时间: 周一至周六 09:00-18:00 (GMT+8)",
    contactInfoNote: "推荐联系方式: 正式报价请使用邮箱，紧急交期确认可电话联系。",
    contactSocialTitle: "社交媒体",
    contactAddressLabel: "办公地址",
    contactAddressValue: "中国浙江省宁波市鄞州区",
    contactEmailLabel: "邮箱地址",
    contactPhoneLabel: "联系电话",
    contactOfficeHoursLabel: "办公时间",
    contactOfficeHoursValue: "周一 - 周五: 9:00 - 18:00 (GMT+8)",
    contactFormTitle: "立即提交您的需求",
    contactFormSubtitle: "我们通常会在 24 小时内回复。",
    contactFieldName: "您的姓名",
    contactFieldNameAria: "输入您的姓名",
    contactFieldEmail: "电子邮箱",
    contactFieldEmailAria: "输入您的电子邮箱",
    contactFieldWhatsApp: "WhatsApp/WeChat (可选)",
    contactFieldWhatsAppAria: "输入您的即时通讯账号",
    contactFieldCompany: "公司名称 (可选)",
    contactFieldCompanyAria: "输入您的公司名称",
    contactFieldSubject: "咨询主题",
    contactFieldSubjectAria: "选择您的咨询主题",
    contactSubjectGeneral: "通用咨询",
    contactSubjectPrice: "获取报价",
    contactSubjectCustom: "定制服务 (OEM)",
    contactSubjectSample: "样品申请",
    contactSubjectOther: "其他",
    contactFieldMessage: "详细需求描述",
    contactFieldMessageAria: "输入您的具体需求描述",
    contactSubmitButton: "发送消息",
    contactSubmittingButton: "正在发送...",
    contactSubmitSuccess: "消息已成功发送！我们将尽快与您联系。",
    contactSent: "消息提交成功。",
    contactResponseTitle: "平均响应时间",
    contactResponseDesc: "标准 RFQ 询盘通常在 8 个工作小时内回复。",
    contactSubmitError: "发送失败，请稍后重试或直接通过邮件联系我们。",
    contactPrivacyNote: "我们承诺保护您的隐私，您的信息仅用于处理此次咨询。",
    contactQuickCtaTitle: "需要即时沟通吗？",
    contactQuickCtaBody: "我们的在线团队可通过 WhatsApp 为您提供快速解答。",
    contactQuickCtaButton: "立即发起聊天",
    contactInquiryGreeting: "您好，我想咨询以下产品:",
    contactInquiryProductPrefix: "产品:",
    contactInquiryQuantity: "数量:",
    contactInquiryDestinationPort: "目的港:",
    navHome: "首页",
    navProducts: "所有产品",
    navYogaMats: "瑜伽垫",
    navYogaBlocks: "瑜伽砖",
    navYogaStraps: "瑜伽拉力带",
    navResistanceBands: "阻力带",
    navPilatesRings: "普拉提圈",
    navFoamRollers: "泡沫轴",
    navSolutions: "解决方案",
    navAbout: "关于我们",
    navContact: "联系我们",
    navCustomization: "定制服务",
    navOemPrivateLabel: "定制与OEM",
    navSolutionsControl: "质量控制",
    navCompanyProfile: "公司简介",
    navContactUs: "联系我们",
    navBlog: "博客",
    btnContactUs: "联系我们",
    btnLogin: "登录",
    btnAccount: "账号",
    btnQuote: "立即询价",
    btnCurrency: "货币",
    btnLanguage: "语言",
    requestQuote: "立即询价",

    navBlogNews: "内容中心",
    footerCopyright: "© 2026 LOYA SPORT. 保留所有权利。",
    footerSlogan: "您可靠的健身产品采购与定制伙伴。",
    footerProducts: "产品中心",
    footerQuickLinks: "快速链接",
    footerContact: "联系我们",
    footerTagline: "聚焦 B2B 供应链整合，让跨境采购更清晰、更稳健。",
    footerAboutUs: "关于我们",
    footerPrivacyPolicy: "隐私政策",
    footerTermsOfService: "服务条款",
    footerCompanyImages: "公司风采",
    footerFaq: "常见问题",
    footerNews: "采购洞察",
    breadcrumbHome: "首页",
    breadcrumbHomeSeries: "产品系列",
    breadcrumbProductDetail: "产品详情",
    pdLoadErrorProductDetail: "加载商品详情失败",
    pdLoadErrorRelatedProducts: "加载相关推荐失败",
    pdLoadErrorStorefrontConfig: "加载店铺配置失败",
    pdLoading: "正在加载商品详情...",
    pdSampleDefaultMessage: "请提供样品政策、交期和报价信息。",
    pdAttrProductName: "产品名称",
    pdAttrModelNo: "型号",
    pdAttrCategory: "分类",
    pdAttrManufacturer: "制造商",
    pdLeadTimeOnRequest: "交期待确认",
    pdLeadTimeUpTo: "不超过 {qty} 件: {days} 天",
    pdLeadTimeFrom: "{qty} 件以上: {days} 天",
    pdLeadTimeDaysOnly: "{days} 天",
    pdContactForQuote: "联系获取报价",
    pdPerPiece: "{price} / 件",
    pdAnonymousBuyer: "匿名买家",
    pdReviewTipSignIn: "请先以客户身份登录后再标记有帮助。",
    pdReviewTipSessionExpired: "登录状态已过期，请重新登录后再试。",
    pdReviewTipNoPermission: "当前账号无法执行此操作。",
    pdReviewTipUpdateFailed: "更新有帮助状态失败",
    pdSpecValues: "可选值",
    pdSpecRequired: "必选",
    pdSpecOptional: "可选",
    pdCapabilityCustomLogo: "支持 Logo 定制",
    pdCapabilitySampleDev: "支持打样开发",
    pdCapabilityPackagingCoordination: "支持包装协同",
    pdCapabilityExportFollowUp: "支持出口发运跟进",
    pdPackagingSellingUnit: "销售单位",
    pdPackagingSingleItem: "单件",
    pdPackagingType: "包装方式",
    pdPackagingTypeFallback: "OPP 袋 / 加厚纸箱",
    pdPackagingLoadingAdvice: "装柜建议",
    pdPackagingLoadingAdviceFallback: "按订单结构确认",
    pdPackagingLeadTime: "交期",
    pdMediaPhotoLabel: "图片 {index}",
    pdMediaVideoLabel: "视频",
    pdMediaAttributesLabel: "属性",
    pdPackagingPointPackaging: "包装: {value}",
    pdPackagingPointLoadingAdvice: "装柜建议: {value}",
    pdPackagingPointShippingPort: "装运港: {value} (可协商)",
    pdPackagingPointShippingPortNegotiable: "装运港: 可协商",
    pdPackagingPointLeadTime: "交期: {value}",
    pdInquiryHello: "您好，我想咨询以下产品:",
    pdInquiryProduct: "产品: {value}",
    pdInquirySku: "SKU: {value}",
    pdInquirySkuName: "SKU 名称: {value}",
    pdInquiryModel: "型号: {value}",
    pdInquiryQuantity: "数量: {value}",
    pdEmailSubject: "询盘: {sku} - {name}",
    pdInquirySubmitFailed: "当前无法提交询盘，请稍后再试。",
    pdSampleContactPerson: "联系人: {value}",
    pdSampleWhatsapp: "WhatsApp/微信: {value}",
    pdSampleCompany: "公司: {value}",
    pdSampleRequestedQuantity: "需求数量: {value}",
    pdSampleSelectorQuantity: "页面数量选择器: {value}",
    pdVariationLabel: "选项",
    pdVariationInquiryIntro: "您好，我想发送如下询盘:",
    pdVariationInquiryQuoteLeadTime: "请提供最新报价和交期信息。",
    pdVideoFallback: "视频加载失败，请重试或直接打开源链接。",
    pdRetry: "重试",
    pdOpenVideoUrl: "打开视频链接",
    pdProductAttributes: "产品属性",
    pdMediaTabsAria: "商品媒体类型",
    pdMediaTabPhotos: "图片",
    pdMediaTabVideo: "视频",
    pdMediaTabAttributes: "属性",
    pdInfoTabsAria: "详情信息标签",
    pdInfoTabAttributes: "属性",
    pdInfoTabDescription: "描述",
    pdInfoTabSupplier: "供应商",
    pdInfoTabReviews: "评价",
    pdKeyAttributes: "关键属性",
    pdPackagingShippingInfo: "包装与运输信息",
    pdProductDescription: "产品描述",
    pdSupplierOverview: "供应商概览",
    pdSupplierOverviewHint: "公司介绍和 FAQ 展示在详情图片下方。",
    pdBuyerFeedback: "买家反馈",
    pdRepeatBuyer: "回购买家",
    pdReviewRatingAria: "评分 {rating} / 5",
    pdReviewMetaColor: "颜色: {value}",
    pdReviewMetaColorFallback: "第二款",
    pdReviewUnavailable: "该产品当前已下架",
    pdReviewHelpful: "有帮助 ({count})",
    pdNoReviews: "该产品暂无评价。",
    pdNoReviewsHint: "可联系团队获取订单参考或样品反馈。",
    pdTitleFallback: "产品详情",
    pdCustomizable: "支持定制",
    pdVariationCardAria: "产品规格选项",
    pdVariations: "规格选项",
    pdSelectNow: "立即选择",
    pdSelectOption: "请选择",
    pdLadderPricingAria: "阶梯报价",
    pdProductSpecifications: "产品规格",
    pdSpecPrevAria: "查看上一个规格值",
    pdSpecNextAria: "查看下一个规格值",
    pdSupplierCapability: "供应商定制能力",
    pdGetFreeSample: "获取免费样品",
    pdWhatsAppInquiry: "WhatsApp 询盘",
    pdEmailInquiry: "邮件询盘",
    pdPackagingDelivery: "包装与交付",
    pdProductVideo: "产品视频",
    pdVideoOpenLink: "当前环境无法播放视频。",
    pdSupplierDescriptions: "供应商产品描述",
    pdCompanyIntroduction: "公司介绍",
    pdNoCompanyIntroduction: "暂未配置公司介绍。",
    pdFaq: "常见问题",
    pdNoFaq: "暂未配置 FAQ。",
    pdCloseVariationSelector: "关闭规格选择器",
    pdVariationSelectAndQty: "选择规格与数量",
    pdVariationStock: " / 库存 {count}",
    pdSelectedQuantity: "已选数量",
    pdSendInquiry: "发送询盘",
    pdChatNow: "立即沟通",
    pdOptionLabel: "选项 {index}",
    pdRelatedAria: "相关推荐",
    pdRelatedTitle: "相关推荐",
    pdRelatedSubtitle: "本分类下买家常一起采购的更多产品。",
    pdRelatedPrevAria: "上一组相关推荐",
    pdRelatedNextAria: "下一组相关推荐",
    pdSampleContactTitle: "请联系我们",
    pdSampleContactDesc: "如有问题我们很乐意协助。可通过 WhatsApp 或邮件联系我们获取样品支持。",
    pdSampleCloseAria: "关闭样品询盘",
    pdSampleSummaryProduct: "产品",
    pdSampleSummaryQuantity: "数量",
    pdFormFullName: "姓名",
    pdFormFullNamePlaceholder: "请输入您的姓名",
    pdFormEmail: "邮箱*",
    pdFormEmailPlaceholder: "用于邮件联系您",
    pdFormWhatsapp: "WhatsApp/微信*",
    pdFormWhatsappPlaceholder: "用于 WhatsApp 联系您",
    pdFormCompany: "公司名称",
    pdFormCompanyPlaceholder: "请输入公司名称",
    pdFormRequiredQuantity: "需求数量",
    pdFormRequiredQuantityPlaceholder: "样品或试单需求数量",
    pdFormMessage: "留言",
    pdFormMessagePlaceholder: "请简要说明产品需求",
    pdFormSending: "发送中...",
    pdFormSendMessage: "发送消息",
    pdFormInquirySuccess: "询盘提交成功。",
    productsAll: "所有产品",
    productsCategories: "产品分类",
    productsFilter: "筛选器",
    productsSort: "排序方式",
    productsSortDefault: "默认排序",
    productsSortPriceLow: "价格：从低到高",
    productsSortPriceHigh: "价格：从高到低",
    productsSearchPlaceholder: "按产品名称搜索...",
    productsResults: "个产品",
    productsNoResults: "没有找到匹配的产品。",
    productsClearFilters: "清除筛选",
    productsPrev: "上一页",
    productsNext: "下一页",
    productsPage: "第",
    productsAddToCart: "加入询价单",
    productsViewDetail: "查看详情",
    productPriceFrom: "起",
    productMoq: "起订量",
    productLeadTime: "预计交期",
    productSpecs: "产品规格",
    productRelated: "相关推荐",
    productInquiryButton: "立即询价",
    productBackToList: "返回列表",
    productDescription: "详细描述",
    productVideo: "演示视频",
    productStatusInStock: "现货",
    productStatusPreOrder: "可预订",
    productStatusOutOfStock: "缺货",
    blogReadMore: "阅读更多",
    blogDateFallback: "近期发布",
    blogHeroDescription: "阅读关于产品采购、贴牌规划、打样协同以及大宗合作的实务文章。",
    blogSearchPlaceholder: "搜索文章主题或关键词...",
    blogFeaturedTitle: "精选洞察",
    blogLatestTitle: "最新文章",
    blogCategoryAll: "全部文章",
    blogCategoryBuyingGuide: "采购指南",
    blogCategoryCustomization: "贴牌定制",
    blogCategorySampleOrder: "打样建议",
    blogCategorySourcing: "供应链实务",
    blogCategoryProductTips: "产品常识",
    blogSeoTitle: "博客与洞察 - LOYA SPORT 供应链整合",
    blogSeoDescription: "为全球买家提供关于瑜伽与健身产品的采购策略、OEM流程和市场趋势的专业见解。",
    blogBrowseTopicTitle: "按主题浏览",
    blogCtaTitle: "准备好推进您的项目了吗？",
    blogCtaDescription: "我们的团队可以为您提供针对性的建议，从打样到批量交付全程跟进。",
    blogCtaPrimary: "立即联系",
    blogCtaSecondary: "了解解决方案",
    blogEmptyFeatured: "暂无精选文章",
    blogEmptyLatest: "没有找到匹配的文章",
    ariaSearch: "搜索",
    solutionsScenarioNextStepTitle: "需要针对性方案吗？",
    solutionsScenarioNextStepBody: "联系我们的项目经理，获取针对您市场的深度组合建议。",
    solutionsScenarioRequestPlan: "咨询定制方案",
    solutionsMixNextStepTitle: "想要开始合作吗？",
    solutionsMixNextStepBody: "我们的团队可以为您协调打样与规格对齐，确保您的第一个组合顺利上线。",
    solutionsMixTalkToTeam: "联系团队",
    authLogin: {
        ...en.authLogin,
        welcomeBack: "欢迎回来",
        brandIntro: "登录后继续采购瑜伽和健身产品。",
        brandBullet1: "快速 RFQ 询价流程",
        brandBullet2: "产品与订单跟进",
        brandBullet3: "B2B 账户支持",
        accountLogin: "账户登录",
        createAccount: "创建账户",
        recoverPassword: "找回密码",
        registrationComplete: "注册完成",
        passwordUpdated: "密码已更新",
        loginDesc: "使用用户名或邮箱和密码继续登录。",
        registerDesc: "通过用户名、邮箱验证和图形验证码创建您的账户。",
        forgotDesc: "输入账户邮箱以接收重置码并设置新密码。",
        registerSuccessDesc: "您的账户已成功创建，我们将自动切回登录界面。",
        resetSuccessDesc: "您的密码已成功更新，我们将自动切回登录界面。",
        redirectHintPrefix: "页面将在",
        redirectHintSuffix: "后切换到登录界面。",
        seconds: "秒",
        loginNow: "立即登录",
        username: "用户名",
        usernamePlaceholder: "至少 3 个字符，例如 loya_buyer",
        usernameHelp: "用户名至少 3 个字符，不能使用保留字，只能包含字母、数字、下划线和短横线。",
        usernameExistsHint: "该用户名已注册，请直接登录或更换其他用户名。",
        usernameExists: "用户名已存在，请更换其他用户名或直接登录。",
        usernameExistsAction: "用户名已存在，去登录",
        usernameAlreadyRegistered: "该用户名已被注册。",
        usernameAvailable: "用户名可用。",
        usernameVerifyFailed: "暂时无法校验用户名，请稍后再试。",
        checkingUsername: "正在检查用户名可用性...",
        email: "邮箱",
        emailPlaceholder: "your@email.com",
        emailCodeTargetHint: "请输入要接收验证码的邮箱地址。",
        emailExistsHint: "该邮箱已注册，请直接登录或使用其他邮箱。",
        emailExists: "邮箱已存在，请使用其他邮箱或前往登录。",
        emailExistsAction: "邮箱已存在，去登录",
        emailAlreadyRegistered: "该邮箱已被注册。",
        emailAvailable: "邮箱可用。",
        emailVerifyFailed: "暂时无法校验邮箱，请稍后再试。",
        checkingEmail: "正在检查邮箱可用性...",
        usernameOrEmail: "用户名或邮箱",
        usernameOrEmailPlaceholder: "用户名或 your@email.com",
        forgotEmailHint: "请输入与账户绑定的邮箱，以便我们发送重置码。",
        password: "密码",
        passwordPlaceholder: "请输入密码",
        confirmPassword: "确认密码",
        confirmPasswordPlaceholder: "请再次输入密码",
        confirmNewPassword: "确认新密码",
        confirmNewPasswordPlaceholder: "请再次输入新密码",
        nickname: "昵称",
        nicknamePlaceholder: "选填，用于展示",
        captcha: "图形验证码",
        registerCaptcha: "注册验证码",
        resetCaptcha: "重置验证码",
        refreshCaptcha: "刷新验证码",
        load: "加载",
        forgotCaptchaHint: "请先完成图形验证码，再请求密码重置码。发送成功后，系统会自动加载一张新的验证码用于最后一步重置。",
        registerCaptchaHint: "请先完成图形验证码，再请求邮箱验证码。",
        registerStepHint: "请先填写用户名、密码、确认密码和有效邮箱，然后才会显示图形验证码和邮箱验证码区域。",
        emailCode: "邮箱验证码",
        emailCodePlaceholder: "6 位验证码",
        resetCode: "重置码",
        resetCodePlaceholder: "6 位重置码",
        sending: "发送中...",
        resendIn: "重新发送倒计时",
        sendEmailCode: "发送邮箱验证码",
        sendResetCode: "发送重置码",
        signingIn: "登录中...",
        login: "登录",
        updating: "更新中...",
        creating: "创建中...",
        resetPassword: "重置密码",
        forgotRequirementHint: "找回密码需要同时完成图形验证码校验和邮箱重置码校验。",
        registerRequirementHint: "注册需要填写发送到您邮箱中的验证码。",
        captchaRefreshHint: "如果看不清验证码，可点击右侧图片刷新。",
        switchToLogin: "已有账户？立即登录",
        switchToRegister: "还没有账户？马上注册",
        backToLogin: "返回登录",
        forgotPassword: "忘记密码？",
        usernameRequired: "请输入用户名，至少 3 个字符。",
        usernameMin: "用户名不能少于 3 个字符。",
        usernameMax: "用户名不能超过 24 个字符。",
        usernamePattern: "用户名只能包含字母、数字、下划线和短横线。",
        usernameReserved: "该用户名为系统保留字，请更换。",
        usernameFormatOk: "用户名格式可用。",
        emailRequired: "请输入邮箱地址。",
        emailInvalid: "请输入合法邮箱地址。",
        emailFormatOk: "邮箱格式可用。",
        emailProviderHint: "建议优先使用常见邮箱，例如 Gmail、Outlook、QQ、163、126、Foxmail。",
        passwordRequired: "请输入密码。",
        didYouMean: "是否想使用",
        passwordMin: "密码长度不能少于 6 位。",
        newPasswordMin: "新密码长度不能少于 6 位。",
        confirmPasswordRequired: "请输入确认密码。",
        passwordMatch: "两次密码输入一致。",
        passwordMismatch: "两次输入的密码不一致。",
        emailCodeRequired: "请输入邮箱验证码。",
        resetCodeRequired: "请输入发送到您邮箱的重置码。",
        captchaRequired: "请输入图形验证码。",
        captchaExpired: "图形验证码已过期，请刷新后重试。",
        captchaIncorrect: "图形验证码错误，请重新输入。",
        registerPrerequisitesError: "请先完成用户名、密码、确认密码和有效邮箱的填写，再请求邮箱验证码。",
        enterCaptchaBeforeEmailCode: "请先输入图形验证码，再发送邮箱验证码。",
        enterCaptchaBeforeResetCode: "请先输入图形验证码，再发送密码重置码。",
        sendEmailCodeFailed: "发送邮箱验证码失败。",
        emailCodeSent: "邮箱验证码已发送。",
        emailCodeSentInbox: "邮箱验证码已发送，请查收邮件。",
        previewCodeCurrentEnv: "当前环境预览码",
        previewCodeDevelopment: "开发环境预览码",
        previewCodeGenerated: "邮箱验证码已生成，当前环境使用预览码。",
        previewCodeContinueRegistration: "请直接输入这 6 位验证码继续注册。",
        tooManyRequests: "发送过于频繁，请稍后再试。",
        smtpConfigRetry: "邮件发送失败，请检查 SMTP 配置后重试。",
        emailServiceNotConfigured: "邮箱发送服务未配置，请联系管理员。",
        requestFailed: "请求失败，请稍后重试或联系支持。",
        registerFailed: "注册失败",
        resetFailed: "密码重置失败",
        loginFailed: "登录失败",
        registerSuccessNotice: "注册成功，约 4 秒后将跳转到登录界面。",
        resetSuccessNotice: "密码重置成功，约 1.5 秒后将跳转到登录界面。",
        loginTokenMissing: "登录令牌缺失",
        profileLoadFailed: "加载账户资料失败",
        loginSuccessAdmin: "登录成功，正在跳转...",
        loginSuccessStorefront: "登录成功，正在跳转到前台页面...",
        loginServiceUnavailable: "登录服务暂时不可用，请稍后再试。",
        orContinueWith: "或使用以下方式继续",
        googleAuthorizing: "正在授权 Google 账户...",
        googleFallbackAction: "使用 Google 继续",
        googleAuthFailed: "Google 授权失败",
        googleAuthOffline: "当前离线或网络不可达，Google 登录暂不可用。请联网后重试，或使用账号密码登录。",
        googleAuthTimeout: "Google 凭证校验超时，请稍后重试；若持续失败，请让管理员检查后端外网访问能力。",
        googleAuthNetworkError: "Google 凭证校验失败（后端网络错误），请联系管理员排查服务器外网访问。",
        googleRegisterSuccess: "Google 账户关联成功，正在跳转到前台页面...",
        googleCreateAccountTitle: "完成 Google 账户创建",
        googleCreateAccountDesc: "Google 已验证你的邮箱。请设置一个密码，完成客户账号创建并继续登录。",
        googleCreateAccountHint: "系统里还没有这个 Google 邮箱对应的账号。请先设置密码创建客户账号。",
        googleLinkedEmailHint: "这个经过 Google 验证的邮箱将直接用于创建客户账号。",
        googleCreatePasswordHint: "请设置并确认密码。系统会用当前 Google 已验证邮箱创建新的客户账号。",
        accountNotFound: "账号不存在，请检查用户名或邮箱。",
        passwordIncorrect: "密码错误，请重新输入。",
        registrationNotOpen: "当前不开放登录和注册。",
        accountRestricted: "账号被限制登录，请联系管理员。"
    },
    auth: {
        loginTitle: "登录账户",
        registerTitle: "注册新账户",
        resetTitle: "找回密码",
        loginAria: "登录表单",
        registerAria: "注册表单",
        resetAria: "重置密码表单",
        emailLabel: "电子邮箱",
        emailPlaceholder: "请输入您的电子邮箱",
        passwordLabel: "密码",
        passwordPlaceholder: "请输入密码",
        confirmPasswordLabel: "确认密码",
        confirmPasswordPlaceholder: "请再次输入密码",
        usernameLabel: "用户名",
        usernamePlaceholder: "请输入用户名",
        rememberMe: "记住我",
        forgotPassword: "忘记密码？",
        loginButton: "立即登录",
        registerButton: "注册账户",
        resetButton: "重置密码",
        backToLogin: "返回登录",
        noAccount: "还没有账户？",
        alreadyHasAccount: "已有账户？",
        createAccount: "创建新账户",
        captchaLabel: "图形验证码",
        captchaPlaceholder: "请输入图形验证码",
        emailCodeLabel: "邮箱验证码",
        emailCodePlaceholder: "请输入 6 位验证码",
        sendEmailCode: "发送验证码",
        sendResetCode: "发送重置码",
        resendIn: "秒后重试",
        nicknameLabel: "昵称 (可选)",
        nicknamePlaceholder: "如何称呼您",
        termsNotice: "注册即表示您同意我们的",
        termsLink: "服务条款",
        privacyLink: "隐私政策",
        usernameRequired: "请输入用户名。",
        usernameFormat: "用户名只能包含字母、数字和下划线。",
        emailRequired: "请输入电子邮箱。",
        emailInvalid: "请输入有效的电子邮箱地址。",
        emailFormatOk: "邮箱格式可用。",
        emailProviderHint: "建议优先使用常见邮箱，例如 Gmail、Outlook、QQ、163、126、Foxmail。",
        didYouMean: "是否想使用",
        passwordMin: "密码长度不能少于 6 位。",
        newPasswordMin: "新密码长度不能少于 6 位。",
        confirmPasswordRequired: "请输入确认密码。",
        passwordMatch: "两次密码输入一致。",
        passwordMismatch: "两次输入的密码不一致。",
        emailCodeRequired: "请输入邮箱验证码。",
        resetCodeRequired: "请输入邮箱重置码。",
        captchaRequired: "请输入图形验证码。",
        registerPrerequisitesError: "请先填写完整用户名、密码、确认密码和有效邮箱，再发送邮箱验证码。",
        enterCaptchaBeforeEmailCode: "请先输入图形验证码，再发送邮箱验证码。",
        enterCaptchaBeforeResetCode: "请先输入图形验证码，再发送密码重置码。",
        sendEmailCodeFailed: "发送邮箱验证码失败，请稍后重试。",
        emailCodeSent: "邮箱验证码已发送。",
        registerFailed: "注册失败",
        resetFailed: "密码重置失败",
        loginFailed: "登录失败",
        registerSuccessNotice: "注册成功，约4秒后将跳转到登录界面。",
        resetSuccessNotice: "密码重置成功，约1.5秒后将跳转到登录界面。",
        loginTokenMissing: "登录令牌缺失",
        profileLoadFailed: "加载账号信息失败",
        loginSuccessAdmin: "登录成功，正在跳转...",
        loginSuccessStorefront: "登录成功，正在跳转到前台...",
        loginServiceUnavailable: "登录服务暂时不可用，请稍后重试。"
    },
    admin: {
        ...en.admin,
        productCategoryYogaMats: "瑜伽垫",
        productCategoryYogaBlocks: "瑜伽砖",
        productCategoryYogaStraps: "瑜伽绳",
        productCategoryResistanceBands: "阻力带",
        productCategoryPilatesRings: "普拉提圈",
        productCategoryFoamRollers: "泡沫轴",
        productCategoryOthers: "其他",
        faqSampleOrderQ: "可以下样品单吗？",
        faqSampleOrderA: "可以，我们支持样品单，欢迎随时联系。",
        faqCustomPackagingQ: "可以定制包装和LOGO吗？",
        faqCustomPackagingA: "可以，支持OEM/ODM定制服务。",
        faqLeadTimeQ: "交货期多久？",
        faqLeadTimeA: "通常1-3天，具体交期下单时确认，视订单数量而定。",
        faqDefectiveItemQ: "如何处理有质量问题的产品？",
        faqDefectiveItemA: "我们提供一年质保，若因材料或工艺问题导致产品损坏，请提供描述、照片/视频及必要时寄回样品，我们工程师会分析并给出解决方案。如需退货，请联系并将产品连同原包装及配件寄回，收到后退款或免费补发。",
        faqWhyChooseUsQ: "为什么选择我们？",
        faqWhyChooseUsA: "我们提供灵活起订、严格质控、OEM/ODM支持和完善售后服务，供货覆盖全球市场。",
        companyImageSectionOverview: "公司介绍",
        companyImageSectionAdvantages: "公司优势",
        companyImageSectionCustomization: "定制能力",
        companyImageSectionExtended: "其他公司介绍",
        companyImageSectionPackaging: "包装运输",
        companyImageSectionFactory: "工厂情况",
        companyImageSectionWorkflow: "生产流程",
        companyImageSectionTradeShow: "参展情况",
        orderStatusPaid: "已付款",
        orderStatusPacked: "已打包",
        orderStatusInTransit: "运输中",
        orderStatusDelivered: "已送达",
        orderStatusCancelled: "已取消",
        tabDescHome: "管理您的工作区运营并监控绩效。",
        tabDescStoreBase: "配置前台/后台标题和SEO元数据。",
        tabDescTemplateStudio: "可视化编辑前台布局模块并保存自定义模板。",
        tabDescArticleManagement: "在独立面板中管理博客文章，并通过弹窗编辑文章内容。",
        tabDescCompanyImages: "管理用于店铺资料内容的公司图片分类。",
        tabDescDesignNav: "配置前台导航和嵌套菜单结构。",
        tabDescDesignCarousel: "管理前台首页轮播图。",
        tabDescDesignBanner: "配置横幅消息和行动号召内容。",
        tabDescFaqKnowledge: "维护运营和销售团队使用的FAQ知识库。",
        tabDescProducts: "管理产品目录、详情和定价信息。",
        tabDescProductCreate: "创建新产品并完善所有信息 and 媒体。",
        tabDescMerchandising: "评估候选产品、定价结构 and 上市准备度。",
        tabDescProcurement: "协调采购计划、供应商进度 and 采购优先级。",
        tabDescQuality: "跟踪质检节点 and 履约前的放行准备。",
        tabDescLogistics: "跟进发货状态、包装准备 and 物流协作。",
        tabDescOrders: "跟踪订单全流程、履约 and 发货更新。",
        tabDescCustomers: "在此管理团队成员及其账号权限。",
        tabDescMarketing: "查看营销活动状态 and 增长表现。",
        tabDescDiscounts: "管理价格策略 and 促销规则。",
        tabDescFinance: "监控财务记录 and 收入趋势。",
        tabDescFinanceIncome: "查看订单回款、已确认收入 and 入账流水。",
        tabDescFinanceExpenses: "登记采购、物流、营销 and 行政等支出账单。",
        tabDescFinanceReceivables: "跟踪应收账款、账龄 and 催收优先级。",
        tabDescFinancePayables: "管理应付账款、供应商付款 and 到期压力。",
        tabDescFinanceInvoices: "维护发票、票据 and 开票状态。",
        tabDescFinanceTax: "复核销项、进项 and 税费预估。",
        tabDescFinanceBudget: "跟踪预算、费用归集 and 超支预警。",
        tabDescFinanceDaily: "按日汇总公司收入、开销 and 现金净额。",
        tabDescFinanceMonthly: "按月完成结账、利润复盘 and 预算偏差分析。",
        tabDescFinanceYearly: "按年复盘营收、费用、税费 and 净利润。",
        tabDescFinanceReconciliation: "核对应收、已收、应付、开票 and 税费状态。",
        tabDescFinanceApprovals: "处理退款、付款 and 费用审批审计。",
        tabDescFinanceReports: "汇总财务报表、经营指标 and 导出任务。",
        tabDescAnalytics: "分析数据洞察 and 运营指标。",
        tabDescSettings: "管理数据库连接等底层系统设置。",
        tabDescWorkTargets: "跟踪 and 协调日常任务目标。",
        tabDescWorkProcessing: "处理分配的工作流 and 执行记录。",
        tabDescHrEmployee: "查看 and 维护员工档案及账号信息。",
        tabDescHrRecruitment: "跟踪入职 and 招聘相关任务队列。",
        tabDescHrAttendance: "监控员工考勤 and 账号活跃状态。",
        tabDescHrOffice: "管理岗位覆盖 and 内部行政任务。",
        tabDescSiteMaintenance: "维护前台内容 and 站点稳定性。",
        tabDescPermissionMaintenance: "维护基于角色的权限 and 访问边界。",
        tabDescPositionMaintenance: "",
        tabDescProfile: "查看您的账号信息。",
        tabDescPassword: "安全修改账号密码。",
        tabDescInquiry: "联系卖家并继续询盘沟通。",
        tabDescWishlist: "管理收藏商品 and 偏好选品。",
        tabDescOrderProcessing: "跟踪 and 处理订单全流程记录。",
        tabDescAfterSales: "跟进售后请求 and 支持工单。",
        roleDeveloper: "开发人员",
        roleSuperAdmin: "超级管理员",
        roleAdmin: "普通管理员",
        roleCustomer: "客户",
        roleGuest: "访客",
        productCreateMenu: "商品发布",
        productsMenu: "商品管理",
        merchandisingOverview: "选品总览",
        merchandisingCollection: "采集池",
        internalOverview: "总览与配置",
        internalWorkspace: "商品与履约",
        internalBusiness: "销售与客户",
        internalOffice: "岗位工作",
        internalMaintenance: "维护面板",
        storefrontContent: "店铺内容",
        guestService: "访客服务",
        customerService: "客户服务",
        commonAccount: "我的账号",
        siteMaintenanceMenu: "岗位管理",
        positionMaintenanceMenu: "用户管理",
        title: "My Store",
        home: "运营总览",
        storeDesign: "店铺搭建",
        companyProfile: "公司资料",
        storeBase: "店铺基础参数",
        templateStudio: "模板工作台",
        articleManagement: "文章管理",
        companyProfileMenu: "公司介绍",
        companyImages: "公司图片",
        designNav: "导航菜单",
        designCarousel: "首页轮播图",
        designBanner: "Banner设置",
        faqKnowledge: "FAQ知识库",
        products: "商品管理",
        productCreate: "新增商品详情",
        merchandising: "选品中心",
        procurement: "采购中心",
        quality: "质检中心",
        logistics: "物流协同",
        orders: "询盘与订单",
        customers: "客户管理",
        marketing: "营销活动",
        discounts: "定价策略",
        finance: "财务概览",
        financeIncome: "入账流水",
        financeExpenses: "支出账单",
        financeReceivables: "应收账款",
        financePayables: "应付账款",
        financeInvoices: "发票管理",
        financeTax: "税务管理",
        financeBudget: "预算费用",
        financeDaily: "日账单",
        financeMonthly: "月度结账",
        financeYearly: "财务年报",
        financeReconciliation: "收支对账",
        financeApprovals: "审批审计",
        financeReports: "报表导出",
        analytics: "数据分析",
        settings: "系统设置",
        menuCommon: "通用",
        menuInternal: "内部",
        menuWorkContent: "工作内容",
        menuMaintenance: "维护面板",
        userManagementGroup: "维护面板",
        menuGuest: "游客",
        menuCustomer: "客户",
        workTargets: "任务目标",
        workProcessing: "工作处理",
        hrEmployee: "员工档案",
        hrRecruitment: "招聘管理",
        hrAttendance: "考勤管理",
        hrOffice: "行政事务",
        siteMaintenance: "岗位维护",
        permissionMaintenance: "权限维护",
        positionMaintenance: "用户管理",
        profile: "个人信息",
        password: "修改密码",
        inquiry: "询盘交流",
        wishlist: "愿望清单",
        orderProcessing: "订单处理",
        afterSales: "售后服务",
        profileCardTitle: "个人信息",
        accountId: "账号ID",
        profileName: "姓名",
        profileEmail: "邮箱",
        profileRole: "角色",
        passwordCardTitle: "修改账户密码",
        currentPassword: "当前密码",
        adminResetPasswordHint: "这里是管理员重置目标用户密码，不需要输入目标用户当前密码。",
        newPassword: "新密码",
        confirmPassword: "确认新密码",
        savePassword: "更新密码",
        passwordUpdated: "密码更新成功。",
        inquiryCardTitle: "询盘沟通",
        inquiryCardBody: "可与卖家团队沟通产品需求、报价与交付计划。",
        openInquiryCenter: "打开询盘页面",
        openWhatsappChat: "WhatsApp沟通",
        permissionSectionTitle: "当前权限集",
        permissionSectionBody: "权限由登录返回信息与岗位结构共同解析得到。",
        placeholderTodo: "该模块已为当前岗位开放，可在此继续扩展具体业务操作。",
        systemConfigTitle: "系统设置中心",
        settingsTabDatabase: "数据库",
        settingsTabDatabaseHint: "连接与连接池配置",
        settingsTabEmail: "邮箱",
        settingsTabEmailHint: "品牌信息与事务邮件模板",
        mysqlHost: "MySQL 主机",
        mysqlPort: "MySQL 端口",
        mysqlDatabase: "MySQL 数据库名",
        mysqlUser: "MySQL 用户名",
        mysqlPassword: "MySQL 密码",
        mysqlPoolSize: "MySQL 连接池大小",
        mysqlConnectTimeoutMs: "MySQL 连接超时 (ms)",
        saveSystemConfig: "保存系统设置",
        systemConfigSavedToast: "系统配置已保存",
        systemConfigPathLabel: "配置文件",
        restartRequiredHint: "保存后需重启后端服务，新的数据库配置才会生效。",
        storefrontTitle: "前台标题",
        adminTitle: "后台标题",
        seoMetaTitle: "SEO标题",
        seoDescription: "SEO描述",
        seoKeywords: "SEO关键词",
        seoCanonicalUrl: "Canonical 地址",
        seoRobots: "SEO robots",
        seoOgTitle: "Open Graph 标题",
        seoOgDescription: "Open Graph 描述",
        seoOgImage: "Open Graph 图片地址",
        seoTwitterCard: "Twitter 卡片类型",
        seoTwitterSite: "Twitter 账号",
        saveBaseSettings: "保存基础参数",
        baseSavedToast: "基础参数已保存",
        hello: "您好，我们开始吧。",
        askAnything: "随便问点什么...",
        supportLine: "有问题吗? 请联系支持团队",
        addStoreName: "添加商店名称",
        firstProduct: "添加您的第一款产品",
        firstProductDesc: "首先请添加一款产品并提供一些关键信息。",
        addProduct: "添加产品",
        importData: "导入",
        customizeStore: "自定义您的在线商店",
        customizeStoreDesc: "选择模板后，添加 logo、颜色 and 图片。",
        customTemplate: "自定义模板",
        payments: "设置 Commerce Payments",
        shipping: "检查您的运费",
        domain: "自定义域名",
        quickSales: "简化市场销售",
        quickSalesDesc: "在多个平台同步销售与管理。",
        storeSettings: "商店设置",
        general: "常规",
        billing: "账单",
        usersPermissions: "用户",
        paginationPrevious: "上一页",
        paginationNext: "下一页",
        paginationPage: "第",
        paginationTotal: "共",
        policies: "政策",
        businessInfo: "企业详细信息",
        contactInfo: "商店联系方式",
        defaults: "商店默认设置",
        businessMode: "业务模式",
        b2b: "B2B",
        b2c: "B2C",
        modeSaved: "店铺模式已更新",
        modeSavedToast: "业务模式切换成功",
        navSettings: "导航菜单",
        navLabel: "子菜单名称",
        navPath: "子菜单链接",
        addSubmenu: "新增子菜单",
        saveNavigation: "保存子菜单列表",
        navSavedToast: "导航菜单已保存",
        bannerSettings: "轮播图列表",
        bannerTitle: "横幅标题",
        bannerAnnotation: "图片注解",
        bannerButtonText: "图片按钮名称",
        bannerButtonLink: "图片按钮链接",
        bannerImageUrl: "横幅图片地址",
        addBanner: "新增横幅",
        removeBanner: "删除",
        saveBanners: "保存轮播图列表",
        bannersSavedToast: "轮播图列表已保存",
        saveFaqKnowledge: "保存FAQ知识库",
        faqKnowledgeSavedToast: "FAQ知识库已保存",
        saveCompanyImages: "保存公司图片配置",
        companyImagesSavedToast: "公司图片配置已保存",
        companyIntroductionTitle: "公司简介",
        companyIntroductionHint: "用于展示企业介绍、优势和服务能力。",
        companyIntroductionPlaceholder: "请输入公司简介内容...",
        addImageUrl: "添加图片地址",
        uploadLocalImages: "上传本地图片",
        addFaq: "添加FAQ",
        saveCarouselImages: "保存轮播图图片",
        carouselImagesSavedToast: "轮播图图片已保存",
        close: "关闭",
        save: "保存",
        create: "创建",
        search: "搜索当前页面数据",
        refresh: "刷新",
        createProduct: "新增商品",
        cancel: "取消",
        edit: "编辑",
        remove: "删除",
        systemSnapshot: "系统快照",
        activeSearch: "当前搜索词",
        none: "（无）",
        orderRecords: "订单记录数",
        userRecords: "用户记录数",
        lastRefresh: "最近刷新时间",
        productsCount: "商品数",
        customersCount: "客户数",
        ordersCount: "订单数",
        revenue: "销售额 USD",
        localeLabel: "语言",
        sku: "SKU",
        name: "名称",
        description: "描述",
        price: "价格 USD",
        imageUrl: "图片地址",
        category: "分类",
        model: "型号",
        titleField: "产品标题",
        detailVideo: "详情视频地址",
        mainImages: "主图（6条链接，每行1条）",
        detailImages: "详情图（链接，每行1条）",
        parameters: "参数（每行 key:value）",
        openCreateProduct: "打开商品详情表单",
        id: "ID",
        serialNumber: "#",
        userId: "用户",
        actions: "操作",
        email: "邮箱",
        role: "角色",
        username: "用户名",
        nickname: "昵称",
        userRole: "用户角色",
        phone: "手机号",
        accountStatus: "账号状态",
        jobTitle: "职位名称",
        registeredAt: "注册时间",
        lastActiveAt: "最近活跃时间",
        statusActive: "启用",
        statusDisactive: "停用",
        permissions: "权限",
        position: "岗位",
        accessSummary: "访问权限",
        positionName: "岗位名称",
        positionKey: "岗位标识",
        department: "部门",
        addPosition: "添加岗位",
        permissionName: "岗位权限名称",
        permissionKey: "岗位权限标识",
        addPermission: "添加权限",
        editPermissions: "编辑权限",
        permissionSelectTitle: "选择权限",
        permissionSelectedSummary: "已选权限",
        permissionQuickSearchPlaceholder: "按权限标识或中文注释快速搜索",
        defaultAdminPosition: "运营管理员",
        orderId: "订单号",
        total: "总额",
        status: "状态",
        cartItems: "购物车商品数",
        logout: "退出登录",
        changePasswordAction: "修改密码",
        userPasswordModalTitle: "修改用户密码",
        userPasswordUpdated: "用户密码修改成功。",
        targetUser: "目标用户",
        userDataResyncedHint: "保存后检测到字段被服务器覆盖，已自动同步最新数据。",
        userManagementRestrictedHint: "该操作需要更高权限。",
        requestQuote: "询价",
        requestFreeSample: "申请免费样品",
        trustTitle: "全球合作伙伴与信任背书",
        factoryStatsSince: "始于1995年",
        factoryStatsSize: "30,000 平方米工厂",
        factoryStatsQC: "100% 产前/产中/产后质检",
        factoryStatsExport: "出口 50+ 国家与地区",
        homeAriaTrust: "信任背书与合作伙伴",
        homeAriaStats: "工厂实力与数据",
        capability: {
            ...en.admin.capability,
            "admin:overview:read": "查看后台总览",
            "admin:products:read": "查看后台商品",
            "admin:products:write": "编辑后台商品",
            "admin:orders:read": "查看后台订单",
            "admin:orders:write": "编辑后台订单",
            "admin:users:read": "查看后台用户",
            "admin:users:role:write": "编辑用户角色",
            "admin:users:position:assign": "分配用户岗位",
            "admin:storefront:read": "查看店铺配置",
            "admin:storefront:write": "编辑店铺配置",
            "admin:system-config:read": "查看系统配置",
            "admin:system-config:write": "编辑系统配置",
            "shop:profile:read": "查看店铺资料",
            "shop:password:write": "修改店铺密码",
            "shop:orders:read": "查看店铺订单",
            "shop:inquiry:write": "处理店铺询盘",
            "shop:wishlist:read": "查看收藏清单",
            "shop:orders:processing:read": "查看订单处理",
            "shop:after-sales:read": "查看售后服务",
            "internal:work:targets:read": "查看工作目标",
            "internal:work:processing:read": "查看工作处理",
            "internal:maintenance:site:write": "编辑站点维护",
            "internal:maintenance:permission:write": "编辑权限维护",
            "internal:maintenance:position:write": "编辑岗位维护",
            "shop:products:read": "查看店铺商品",
            "shop:storefront:read": "查看店铺前台",
            "internal:system:config:read": "查看内部系统配置",
            "internal:system:config:write": "编辑内部系统配置",
            "internal:security:audit:read": "查看安全审计",
            "internal:security:session:revoke": "撤销会话",
            "internal:integration:manage": "管理系统集成",
            "admin:users:write": "编辑后台用户",
            "admin:users:password:reset": "重置用户密码",
            "admin:users:delete": "删除后台用户",
            "crm:customer:read": "查看客户资料",
            "crm:customer:write": "编辑客户资料",
            "crm:customer:assign": "分配客户归属",
            "website:content:read": "查看网站内容",
            "website:content:write": "编辑网站内容",
            "website:navigation:write": "编辑网站导航",
            "website:banner:write": "编辑网站横幅",
            "website:seo:write": "编辑SEO设置",
            "website:theme:write": "编辑网站主题",
            "website:publish": "发布网站内容",
            "admin:products:create": "创建后台商品",
            "admin:products:delete": "删除后台商品",
            "merchandising:selection:read": "查看选品池",
            "merchandising:selection:write": "编辑选品池",
            "catalog:pricing:write": "编辑商品定价",
            "catalog:inventory:write": "编辑库存信息",
            "catalog:translation:write": "编辑商品翻译",
            "sales:inquiry:read": "查看销售询盘",
            "sales:inquiry:reply": "回复销售询盘",
            "sales:quotation:create": "创建销售报价",
            "sales:quotation:approve": "审批销售报价",
            "sales:contract:write": "编辑销售合同",
            "sales:sample:manage": "管理样品流程",
            "order:status:update": "更新订单状态",
            "order:split:merge": "拆分或合并订单",
            "procurement:purchase:write": "编辑采购单",
            "production:plan:write": "编辑生产计划",
            "qa:inspection:write": "编辑质检记录",
            "logistics:shipment:write": "编辑发运信息",
            "logistics:tracking:read": "查看物流追踪",
            "trade:customs:doc:write": "编辑报关单证",
            "finance:invoice:read": "查看发票",
            "finance:invoice:write": "编辑发票",
            "finance:payment:read": "查看付款",
            "finance:payment:write": "编辑付款",
            "finance:refund:approve": "审批退款",
            "finance:reconciliation:write": "编辑财务对账",
            "finance:tax:write": "编辑税务信息",
            "marketing:campaign:read": "查看营销活动",
            "marketing:campaign:write": "编辑营销活动",
            "marketing:coupon:write": "编辑优惠券",
            "marketing:lead:export": "导出销售线索",
            "analytics:dashboard:read": "查看数据看板",
            "analytics:report:export": "导出分析报表",
            "support:ticket:read": "查看客服工单",
            "support:ticket:write": "编辑客服工单",
            "support:return:approve": "审批退货申请",
            "support:complaint:handle": "处理客户投诉",
            "office:announcement:write": "发布办公公告",
            "office:document:read": "查看办公文档",
            "office:document:write": "编辑办公文档",
            "office:workflow:approve": "审批办公流程",
            "office:meeting:manage": "管理会议安排",
            "hr:employee:read": "查看员工档案",
            "hr:employee:write": "编辑员工档案"
        }
    },
    carouselLoadingTitle: "正在加载轮播图片",
    carouselLoadingBody: "我们正在为您准备首页视觉内容，请稍候，轮播图片加载中。",
    carouselPlaceholderTitle: "轮播图片准备中",
    carouselPlaceholderBody: "图片资源就绪后，首页轮播将在此显示。",
    aboutProductDev: "产品开发",
    aboutProductDevDesc: "快速打样周期与务实设计协同，帮助更快上市。",
    aboutSupplyReliability: "供应稳定性",
    aboutSupplyReliabilityDesc: "稳定的材料采购与产能规划，保障旺季也能按计划交付。",
    aboutTradeSupport: "交付与售后支持",
    aboutTradeSupportDesc: "提供单证、出运协调与售后支持，让国际业务更顺畅。",
    aboutSupplyList1: "针对瑜伽与轻健身品类的已验证供应商协同",
    aboutSupplyList2: "与合作工厂联合执行多阶段质量复核",
    aboutSupplyList3: "支持贴牌与包装定制",
    aboutSupplyList4: "覆盖主要区域与渠道的全球供应支持",
    oemCapability1: "为核心瑜伽配件提供定制 Logo 印刷、压纹与激光标记。",
    oemCapability2: "按目标市场调整颜色、材质、纹理与尺寸。",
    oemCapability3: "提供可上架包装、内卡、条码标签与外箱标识。",
    oemCapability4: "支持工作室套装、Amazon 组合包与季节性促销组合开发。",
    news1Title: "春季采购指南发布",
    news1Body: "了解即将到来的零售季中，瑜伽、普拉提与恢复类产品的最新趋势。",
    news2Title: "OEM 包装升级",
    news2Body: "我们现已为贴牌项目提供更环保的外箱、内卡与条码包装选项。",
    news3Title: "出口排期通知",
    news3Body: "我们每周更新交期规划与出货窗口，帮助买家更准确地安排上新节奏。",
    seeAllCategories: "查看全部分类",
    productDetailReady: "支持贴牌定制",
    productDetailQuote: "询价后报价",
    productDetailViewSpecs: "查看规格",
    productDetailRequestQuote: "立即询价",
    oemProjectBrief: "项目简述",
    newsHeroKicker: "行业动态",
    newsTitle: "新闻与更新",
    newsIntro: "关注我们的最新采购洞察、产品上新信息与出口更新，助力健身配件买家决策。",
    newsSectionTitle: "如需定制项目公告或新品系列预览，请联系销售团队获取最新目录。",
    contactName: "您的姓名",
    contactEmail: "工作邮箱",
    contactCompany: "公司名称",
    contactMessage: "产品规格、数量、发货目的地",
    contactSubmit: "发送询盘",
    aboutTitle: "关于 LOYA SPORT",
    aboutIntro: "LOYA SPORT 是服务全球 B2B 买家的瑜伽产品供应链整合商。",
    aboutWhoWeAre: "我们是谁",
    aboutWhoWeAreDesc1: "我们通过已验证供应伙伴协同采购、打样、品牌与出运跟进，为进口商、分销商、零售商和贴牌品牌提供支持。",
    aboutWhoWeAreDesc2: "我们的优势在于务实沟通、品类聚焦和清晰采购流程，帮助海外客户更快推进项目。",
    aboutSupplyCapabilities: "供应能力",
    aboutMission: "我们的使命",
    aboutMissionDesc: "通过可靠采购、严格质控与完整售后支持，帮助健身品牌和零售买家实现增长。",
};
